import { slugToMatch } from "@/utils/slug";

export const defaultSeo = {
  title: "Oh Yes Home Services Kerala | Cleaning & Repairs",
  description:
    "Oh Yes Home Solutions - Trusted home services in Kerala. Expert cleaning, AC, plumbing, electrical & appliance repair at affordable prices.",
};

export const pageSeo = {
  about: {
    title: "Oh Yes About Us | Expert Home Services Across Kerala",
    description:
      "Oh Yes offers trusted and affordable home service across Kerala. Discover our mission, expert team, and commitment to quality service for every home.",
  },
  services: {
    title: "Oh Yes Services - Trusted Home Service Experts",
    description:
      "Explore Oh Yes World's AC repair, cleaning, plumbing & electrical services. Book trusted experts online for fast, reliable home solutions today.",
  },
  blog: {
    title: "Oh Yes Blog - Home Service Tips & Expert Guides",
    description:
      "Read the Oh Yes blog for home service tips, maintenance guides, and expert advice on AC, cleaning, plumbing, and electrical services. Stay informed.",
  },
  news: {
    title: "Latest News & Updates | Oh Yes Home Services",
    description:
      "Stay updated with the latest news, service updates, offers, and announcements from Oh Yes World. Explore trends in home services.",
  },
};

const serviceSeoItems = [
  {
    keywords: ["ac", "air-conditioner", "air conditioner"],
    title: "Oh Yes AC Service - Fast and Trusted Professionals",
    description:
      "Book trusted AC repair, installation & maintenance with Oh Yes World. Skilled technicians, easy online booking & reliable support at your doorstep.",
  },
  {
    keywords: ["cleaning", "deep-cleaning", "deep cleaning", "pest"],
    title: "Oh Yes Cleaning Service - Safe & Trusted Expert",
    description:
      "Oh Yes World offers safe, trusted home, office & deep cleaning by professionals. Book online easily for a clean, healthy space at affordable prices.",
  },
  {
    keywords: ["plumbing", "plumber"],
    title: "Oh Yes - Expert Plumbing Services in Kerala",
    description:
      "Oh Yes provides reliable pipe repair, leak fixing & plumbing installation. Book trusted plumbers online for quick, hassle-free service at your door.",
  },
  {
    keywords: ["electrical", "electrician", "electric"],
    title: "Oh Yes Electrical Services - Quick & Trusted Help",
    description:
      "Oh Yes offers trusted electrical wiring, repair & installation. Book certified electricians online for safe, reliable service at your doorstep.",
  },
  {
    keywords: ["appliance", "washing-machine", "fridge", "refrigerator"],
    title: "Oh Yes Appliance Repair - Expert Repairing & Services",
    description:
      "Get expert appliance repair services with Oh Yes. Washing machine, fridge, and home appliance repair by trusted technicians. Book service easily online.",
  },
  {
    keywords: ["painting", "painter"],
    title: "Oh Yes Painting Service - Professional Painters",
    description:
      "Oh Yes offers professional home & office painting by skilled painters. Book trusted experts online for quality, clean finishing at affordable prices.",
  },
  {
    keywords: ["interior", "interiors", "designer", "designers"],
    title: "Oh Yes Interior - Trusted Home Designers",
    description:
      "Oh Yes offers trusted interior design by expert home designers. Get modern, stylish & functional living spaces. Book interior services online today.",
  },
  {
    keywords: ["garden", "gardening", "landscaping", "lawn"],
    title: "Oh Yes Garden Services - Garden Design Expert",
    description:
      "Oh Yes provides trusted garden services with expert lawn care, landscaping, and garden design. Book professional gardeners for a beautiful outdoor space.",
  },
  {
    keywords: ["construction", "builder", "builders", "home-builder"],
    title: "Oh Yes Construction Service - Build Your Dream Home",
    description:
      "Oh Yes offers trusted interior design by expert home designers. Get modern, stylish & functional living spaces. Book interior services online today.",
  },
  {
    keywords: ["water-purifier", "water purifier", "ro"],
    title: "Oh Yes - Water Purifier Repair & Service Expert",
    description:
      "Oh Yes offers trusted RO repair, installation & maintenance. Book expert water purifier services for clean, safe drinking water at home or office.",
  },
];

function normalize(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[_/]+/g, "-")
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function getServiceSeo(value) {
  const normalized = normalize(slugToMatch(decodeURIComponent(value || "")));

  return (
    serviceSeoItems.find((item) =>
      item.keywords.some((keyword) => normalized.includes(normalize(keyword))),
    ) || null
  );
}

export function resolveSeo(to) {
  const metaSeo =
    typeof to.meta?.seo === "function" ? to.meta.seo(to) : to.meta?.seo;

  if (metaSeo) {
    return metaSeo;
  }

  return defaultSeo;
}
